import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];
  declare readonly modalTarget: HTMLDialogElement;

  open() {
    this.modalTarget.showModal();
  }
}
